import ShiftTimesJSON from 'app/assets/jsons/ShiftTimes.json';

export function GetShiftTimes() {
  const data = ShiftTimesJSON.shiftTimes;
  return data;
}
